module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="page-header header-region">\n	<div class="page-header__inner">\n		<div class="page-header__content">\n			<div class="page-header__details page-header-details__region"><div class="page-header__title">'+
((__t=( _.get(getPageModel(), 'title') ))==null?'':__t)+
'</div></div>\n			<div class="page-header__options">\n				';
 _.forEach(_.get(getPageModel(), 'buttons'), function(button) { 
__p+='\n					<a class="'+
((__t=( getConditionalStr(button.icon, 'm-btn-icon', 'm-btn') ))==null?'':__t)+
' '+
((__t=( getConditionalStr(button.primary, 'm-btn--primary','') ))==null?'':__t)+
' m-btn--'+
((__t=( button.slug ))==null?'':__t)+
' js-header-button" role="button" data-action="'+
((__t=( button.action ))==null?'':__t)+
'">'+
((__t=( button.label ))==null?'':__t)+
'</a>\n				';
 }) 
__p+='\n			</div>\n			<div class="page-header__filter filter-region"></div>\n			<div class="page-header__tabs ">\n				<div class="page-header-tabs__inner header-tabs-region js-tabs"></div>\n			</div>\n		</div>\n	</div>\n</div>\n\n<div class="page-tabs">\n	<div class="page-tabs__inner ">\n		<div class="page-tabs__tabs page-tabs-region js-tabs"></div>\n	</div>\n</div>\n\n<div class="page-body">\n	<div class="page-body__inner">\n		<div class="page-body__content body-region"></div>\n	</div>\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/page-view/templates/layout.html
// module id = 412
// module chunks = 0